import { useNavigate } from "react-router-dom";
import About from "../components/about";
import CTA from "../components/cta";
import Features from "../components/Features";
import Getstarted from "../components/getstarted";
import PublicLayout from "../components/layout/PublicLayout";

export default function Hero() {
  const navigate=useNavigate();
  return (
    <PublicLayout>
      <section className="min-h-screen bg-gradient-to-b from-[#4916CF] via-[#250B69] to-[#0a0015] pt-32 pb-20 px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center">
          <h1
            className="font-sans md:text-[124px] font-bold text-white mb-4"
            style={{
              fontFamily: "DM Sans",
              fontWeight: 500,
              fontSize: "100px",
              lineHeight: "127px",
              letterSpacing: "-1%",
              textAlign: "center",
            }}
          >
            Gamified Proof of Work Simulation Tool
          </h1>

          <p className="text-white/70 text-lg md:text-2xl mb-12 max-w-3xl mx-auto">
            Your Blockchain Learning Journey Simplified
          </p>

          <button
            onClick={() => navigate("/dashboard")}
            className="px-8 py-3 bg-[#4916CF] text-white rounded-full font-medium hover:bg-[#3a0fa8] transition-colors mb-16"
          >
            Get Started
          </button>

          {/* Feature Cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto mb-12">
            <div className="bg-[#4916CF]/20 backdrop-blur rounded-lg p-8 text-left hover:bg-[#4916CF]/30 transition-colors">
              <div className="w-16 h-16 border-2 border-white/30 rounded-2xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56823 3.03617 8.69181 1.52242 12.3463C0.00866569 16.0008 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9991 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9944 14.6974 37.8855 9.61356 34.136 5.86405C30.3864 2.11453 25.3026 0.00559965 20 0ZM20 36.9231C16.6529 36.9231 13.381 35.9305 10.598 34.071C7.81506 32.2115 5.64599 29.5685 4.36512 26.4762C3.08426 23.3839 2.74912 19.9812 3.4021 16.6985C4.05508 13.4157 5.66685 10.4003 8.03358 8.03358C10.4003 5.66684 13.4157 4.05508 16.6985 3.40209C19.9812 2.74911 23.3839 3.08425 26.4762 4.36511C29.5685 5.64598 32.2115 7.81505 34.071 10.598C35.9306 13.381 36.9231 16.6529 36.9231 20C36.918 24.4867 35.1334 28.7882 31.9608 31.9608C28.7882 35.1334 24.4867 36.918 20 36.9231ZM32.3077 20C32.3077 20.408 32.1456 20.7993 31.8571 21.0879C31.5686 21.3764 31.1773 21.5385 30.7692 21.5385H20C19.592 21.5385 19.2007 21.3764 18.9121 21.0879C18.6236 20.7993 18.4615 20.408 18.4615 20V9.23077C18.4615 8.82274 18.6236 8.43143 18.9121 8.14291C19.2007 7.85439 19.592 7.69231 20 7.69231C20.408 7.69231 20.7993 7.85439 21.0879 8.14291C21.3764 8.43143 21.5385 8.82274 21.5385 9.23077V18.4615H30.7692C31.1773 18.4615 31.5686 18.6236 31.8571 18.9121C32.1456 19.2007 32.3077 19.592 32.3077 20Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
              <h3 className="text-white font-bold mb-2">Live Process Visualization</h3>
              <p className="text-white/60 text-sm">
                Watch blockchain processes unfold in real time — explore each step, identify what worked or failed, and uncover the logic driving every transaction.
              </p>
            </div>

            <div className="bg-[#4916CF]/20 backdrop-blur rounded-lg p-8 text-left hover:bg-[#4916CF]/30 transition-colors">
              <div className="w-16 h-16 border-2 border-white/30 rounded-2xl flex items-center justify-center mb-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M36 3V22.5C36 23.2956 35.6839 24.0587 35.1213 24.6213C34.5587 25.1839 33.7957 25.5 33 25.5H12.6206L14.5613 27.4387C14.7006 27.5781 14.8112 27.7436 14.8866 27.9257C14.962 28.1077 15.0008 28.3029 15.0008 28.5C15.0008 28.6971 14.962 28.8923 14.8866 29.0743C14.8112 29.2564 14.7006 29.4219 14.5613 29.5613C14.4219 29.7006 14.2564 29.8112 14.0743 29.8866C13.8923 29.962 13.6971 30.0008 13.5 30.0008C13.3029 30.0008 13.1077 29.962 12.9257 29.8866C12.7436 29.8112 12.5781 29.7006 12.4387 29.5613L7.93875 25.0613C7.79928 24.9219 7.68865 24.7565 7.61316 24.5744C7.53767 24.3923 7.49882 24.1971 7.49882 24C7.49882 23.8029 7.53767 23.6077 7.61316 23.4256C7.68865 23.2435 7.79928 23.0781 7.93875 22.9387L12.4387 18.4387C12.7202 18.1573 13.102 17.9992 13.5 17.9992C13.898 17.9992 14.2798 18.1573 14.5613 18.4387C14.8427 18.7202 15.0008 19.102 15.0008 19.5C15.0008 19.898 14.8427 20.2798 14.5613 20.5613L12.6206 22.5H33V3H12V4.5C12 4.89782 11.842 5.27936 11.5607 5.56066C11.2794 5.84196 10.8978 6 10.5 6C10.1022 6 9.72064 5.84196 9.43934 5.56066C9.15804 5.27936 9 4.89782 9 4.5V3C9 2.20435 9.31607 1.44129 9.87868 0.87868C10.4413 0.31607 11.2044 0 12 0H33C33.7957 0 34.5587 0.31607 35.1213 0.87868C35.6839 1.44129 36 2.20435 36 3ZM25.5 30C25.1022 30 24.7206 30.158 24.4393 30.4393C24.158 30.7206 24 31.1022 24 31.5V33H3V13.5H23.3794L21.4387 15.4387C21.1573 15.7202 20.9992 16.102 20.9992 16.5C20.9992 16.898 21.1573 17.2798 21.4387 17.5613C21.7202 17.8427 22.102 18.0008 22.5 18.0008C22.898 18.0008 23.2798 17.8427 23.5613 17.5613L28.0613 13.0613C28.2007 12.9219 28.3114 12.7565 28.3868 12.5744C28.4623 12.3923 28.5012 12.1971 28.5012 12C28.5012 11.8029 28.4623 11.6077 28.3868 11.4256C28.3114 11.2435 28.2007 11.0781 28.0613 10.9387L23.5613 6.43875C23.2798 6.15729 22.898 5.99917 22.5 5.99917C22.102 5.99917 21.7202 6.15729 21.4387 6.43875C21.1573 6.72021 20.9992 7.10195 20.9992 7.5C20.9992 7.89805 21.1573 8.27979 21.4387 8.56125L23.3794 10.5H3C2.20435 10.5 1.44129 10.8161 0.87868 11.3787C0.31607 11.9413 0 12.7044 0 13.5V33C0 33.7957 0.31607 34.5587 0.87868 35.1213C1.44129 35.6839 2.20435 36 3 36H24C24.7956 36 25.5587 35.6839 26.1213 35.1213C26.6839 34.5587 27 33.7957 27 33V31.5C27 31.1022 26.842 30.7206 26.5607 30.4393C26.2794 30.158 25.8978 30 25.5 30Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h3 className="text-white font-bold mb-2">
                Hands-On Blockchain Experience
              </h3>
              <p className="text-white/60 text-sm">
                Step into the blockchain ecosystem through dynamic simulations — learn to build, mine, and validate blocks just like in a live network.              </p>
            </div>
          </div>
        </div>
      </section>
      <About />
      <Features />
      <CTA />
      <Getstarted />
    </PublicLayout>
  );
}
